import React from "react";
import { Box } from "@material-ui/core"
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { I18n } from "@aws-amplify/core";

export const UserStatus = ({ active }) => {
    return active ? (
        <Box display="flex" alignItems="center" color="green">
            <CheckCircleIcon fontSize="small" style={{ marginRight: 6 }} />
            {I18n.get("profiles_active")}
        </Box>
    ) : (
        <Box display="flex" alignItems="center" color="red">
            <CancelIcon fontSize="small" style={{ marginRight: 6 }} />
            {I18n.get("profiles_inactive")}
        </Box>
    )
}